// Derives an insurance/licence/accreditation row's status from its dates +
// reminder offsets. Mirrors the backend AEST anchor; the `expiring` window
// is reminderDays-driven with a 30-day floor so a customised reminder set
// never tightens the urgency window past the standard.

import type { InsuranceStatus } from "../types";
import { getBrisbaneToday } from "./getBrisbaneToday";

function addDays(isoDate: string, days: number): string {
  const [y, m, d] = isoDate.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d + days));
  return dt.toISOString().slice(0, 10);
}

export function deriveInsuranceStatus(
  expiryDate: string | undefined,
  startDate: string | undefined,
  reminderDays: number[] | undefined,
  // Injectable for determinism — callers (and the renewal hook) pass a fixed
  // anchor so expiring/expired outcomes don't drift with the wall clock.
  // Defaults to Brisbane-now to keep every existing 3-arg call site unchanged.
  today: string = getBrisbaneToday(),
): InsuranceStatus | undefined {
  if (!expiryDate) return undefined;
  if (startDate && startDate > today) return "upcoming";
  if (expiryDate < today) return "expired";
  const threshold = Math.max(...(reminderDays ?? []), 30);
  const cutoff = addDays(today, threshold);
  if (expiryDate <= cutoff) return "expiring";
  return "current";
}
